// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"619":"7f4c3358","651":"819c438a","746":"25dc58ee","858":"f8049dea"}[chunkId] + ".chunk.js";
};